const TOKEN_KEY = 'yt_admin_token';
const USERNAME_KEY = 'yt_admin_username';
const ROLES_KEY = 'yt_admin_roles';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getUsername() {
  return localStorage.getItem(USERNAME_KEY) || '';
}

export function setUsername(username: string) {
  localStorage.setItem(USERNAME_KEY, username);
}

export function getRoles() {
  try {
    return JSON.parse(localStorage.getItem(ROLES_KEY) || '[]') as string[];
  } catch {
    return [];
  }
}

export function setRoles(roles: string[]) {
  localStorage.setItem(ROLES_KEY, JSON.stringify(roles));
}

export function clearSession() {
  clearToken();
  localStorage.removeItem(USERNAME_KEY);
  localStorage.removeItem(ROLES_KEY);
}
